export default __webpack_public_path__ + "eb64a1e.png";